import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface EditIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const EditIcon: React.FC<EditIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-edit">
    <path
      d="M16 30 L16 34 L20 34
        L34 20 L30 16 Z
        M35 19 L31 15"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />
  </SvgIcon>
);

export default EditIcon;
